var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"fontos-icon drawer-controller",attrs:{"icon":"","large":""},on:{"click":function($event){$event.stopPropagation();return _vm.ToggleDrawer($event)}}},[_c('i',{staticClass:"fas fa-bars primary--text"})])}
var staticRenderFns = []

export { render, staticRenderFns }